export const LEGACY_SESSION_TOKEN_KEY = 'cognite-app-legacy-access-token';
export const MODAL_WIDTH = 400;

export const DB_TABLE_SEPARATOR = '43jf5aBPMnMI';
export const RESOURCE_SELECTOR_LIMIT = 1000;
export const AZURE_APP_RESOURCE_ID = '00000002-0000-0000-c000-000000000000';

export const GOOGLE_LOGIN_URL = 'https://accounts.google.com/o/oauth2/v2/auth';
export const GOOGLE_LOGOUT_URL = 'https://accounts.google.com/logout';
export const GOOGLE_TOKEN_URL = 'https://www.googleapis.com/oauth2/v4/token';
